import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconsModule } from "@mk/med-icons";
import { MedE2eTestIdModule } from "@mk/med-auto-test-id";

import { MedTableComponent } from "./med-table.component";
import { MedTableCellComponent } from "./med-table-cell/med-table-cell.component";
import { MedTableHeadCellComponent } from "./med-table-head-cell/med-table-head-cell.component";
import { MedDirectiveSharedModule } from "../../directives/med-directive-shared.module";
import { GetCellMinWidthPipe } from "./pipes/getCellMinWidth.pipe";
import { GetCellMaxWidthPipe } from "./pipes/getCellMaxWidth.pipe";
import { GetCellLeftPipe } from "./pipes/getCellLeft.pipe";
import { IsCellHiddenPipe } from "./pipes/isCellHidden.pipe";
import { MedBtnModule } from "../med-btn/med-btn.module";
import { VisibleExpandRowPipe } from "./pipes/visibleExpandRow.pipe";

@NgModule({
  declarations: [
    MedTableComponent,
    MedTableCellComponent,
    MedTableHeadCellComponent,
    IsCellHiddenPipe,
    VisibleExpandRowPipe,
    GetCellMinWidthPipe,
    GetCellMaxWidthPipe,
    GetCellLeftPipe,
  ],
  imports: [
    CommonModule,
    MedDirectiveSharedModule,
    MedIconsModule,
    MedBtnModule,
    MedE2eTestIdModule,
  ],
  exports: [
    MedTableComponent,
    MedTableCellComponent,
    MedTableHeadCellComponent,
  ],
})
export class MedTableModule { }
